<div class="navbar">
  <nav style="width: 100%;">
   <img style="width: 2%; float: left" src="../../../assets/images/Toyota_logo.png" class="toyota-logo"
      alt="Toyota Logo" />

    <span style="width: 4%; float: left" class="project-heading">
      LIOS
    </span>

   <app-lios-navbar class="lios-menu"></app-lios-navbar>
   
   <mat-nav-list style="float: right" class="inline row-layout">
			<a mat-list-item class="user-details-header" style="height: 40px" [matMenuTriggerFor]="beforeMenu"
			[disableRipple]="true">
			<div class="usermenu">
				<mat-icon class="user-icon">account_circle</mat-icon>
				<div>
				<div class="user-sub-text">{{ userName }}</div>
				<div class="user-sub-text-site">{{ " " }}</div>
				</div>
				<mat-icon class="user-arrow-down">expand_more</mat-icon>
			</div>
			</a>

			<mat-menu #beforeMenu="matMenu" xPosition="before" class="usermenu">
			<button mat-menu-item *ngFor="let role of rolesArray" class="user-items-text" style="width: auto; padding: 7px !important">
				{{ role }}
			</button>
			<button (click)="logout()" mat-menu-item class="user-items-text" style="width: auto; padding: 7px">
				<mat-icon>logout</mat-icon>
				LOGOUT
			</button>
			</mat-menu>
		</mat-nav-list>

   </nav>
</div>